import type { ThisWeekend, LineupWeekend } from '../types/popup'

export const thisWeekend: ThisWeekend = {
  label: '2nd Anniversary',
  title: 'The Pavilion Turns Two',
  days: [
    { weekday: 'Sat', date: 'Oct 17' },
    { weekday: 'Sun', date: 'Oct 18' },
  ],
  hours: '12 – 6 PM',
  intro:
    "We're celebrating two years at India Basin all weekend long, with our own kitchen team on the line. It's also the debut of the brand-new Food Pavilion menu, which will be served on Mondays and Wednesdays.",
  video:
    'https://cdn.magicpatterns.com/uploads/4uJ3AAHiyZitHu75c3dv9X/AACC2B7A-AB03-43FA-9123-8DADCB770759.mov',
}

export const weekendLineup: LineupWeekend[] = [
  {
    status: 'now',
    when: 'This Weekend',
    days: [
      { weekday: 'Sat', date: 'Oct 17' },
      { weekday: 'Sun', date: 'Oct 18' },
    ],
    name: 'The Food Pavilion Team',
    note: 'Our 2nd anniversary celebration and the first taste of our new menu.',
    href: '#menu',
  },
  {
    status: 'next',
    when: 'Up Next',
    days: [
      { weekday: 'Sat', date: 'Oct 24' },
      { weekday: 'Sun', date: 'Oct 25' },
      { weekday: 'Sat', date: 'Oct 31' },
      { weekday: 'Sun', date: 'Nov 1' },
    ],
    name: 'Fusion Rolls',
    note: 'Menu reveal coming soon.',
    logo: 'https://cdn.magicpatterns.com/uploads/oDvjMdRQgqv3RC3gE2M44R/IMG_7202.png',
  },
]
